"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IResponseData.js.map